import axios from "axios";
import { del, get, post, patch,  put } from "./internship_structures_api_helper";
import * as url from "./internship_structures_url_helper";





// Get features
export const getInternshipStructures = () => get(url.GET_INTERNSHIP_STRUCTURES);




export const addNewInternshipStructure = internshipStructure => post(url.ADD_NEW_INTERNSHIP_STRUCTURE, internshipStructure);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateInternshipStructure = internshipStructure => patch(`${url.UPDATE_INTERNSHIP_STRUCTURE}/${internshipStructure.id}`,  internshipStructure);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteInternshipStructure = internshipStructure => del(`${url.DELETE_INTERNSHIP_STRUCTURE}/${internshipStructure.id}`);







export {
  //getLoggedInUser,
  
  
};
